namespace GeniuzPOS.Purchase {
    export class PoParaColumns {
        static columnsKey = 'Purchase.PoPara';
    }
}
